
















import { removeNetCredit } from '@/api/Users/users.api'
import ActionButton from '@/components/ActionButton.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { TopUpAgent } from '@/utils/interfaces/topup.interface'
import Vue, { PropType } from 'vue'
export default Vue.extend({
  components: {
    appActionButton: ActionButton,
    appConfirmDialog: ConfirmDialog,
  },
  props: {
    item: Object as PropType<TopUpAgent>,
  },
  data() {
    return {
      loading: false,
      confirmDialog: false,
    }
  },
  methods: {
    async onDone(payload: boolean) {
      if (payload) {
        this.loading = true
        try {
          const response = await removeNetCredit(this.item.uuid)
          this.$emit('credit-removed', response.data)
        } finally {
          this.loading = false
        }
      }
    },
    removeCredit() {
      this.confirmDialog = true
    },
  },
})
